import React from "react";
import { benamingKlachtenObject } from "../../klantenregister";
import { useNavigate } from "react-router-dom";

const RPProgressbarVragenlijst = ({
  preintake,
  klachtenregistratie,
  voedingsdagboek,
}) => {
  const navigate = useNavigate();
  const voedingStatus =
    typeof voedingsdagboek?.status === "number"
      ? voedingsdagboek.status
      : 0;

  return (
    <div
      onClick={() => navigate("/healthforms")}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate("/healthforms");
        }
      }}
      className="flex w-full min-w-0 flex-1 cursor-pointer flex-col gap-0 rounded-lg border border-wa-border bg-wa-panel p-4 sm:p-6 outline-none ring-wa-accent focus-visible:ring-2"
    >
      <div className="mb-4 text-center text-lg font-semibold text-wa-text">
        Vragenlijsten
      </div>

      <div className="w-full border-b border-wa-border pb-4">
        <nav
          aria-label="Voortgang preintake"
          className="flex w-full flex-col gap-3 sm:flex-row sm:items-start sm:justify-between"
        >
          <div className="min-w-0 flex-shrink-0 sm:max-w-[50%]">
            <p className="text-sm font-semibold text-wa-text">
              Preintake formulier
            </p>
            <p className="text-sm text-wa-muted">
              Ingevuld{" "}
              {Object.entries(preintake).reduce(
                (sum, [, value]) =>
                  sum + (value != null && value !== "" ? 1 : 0),
                0
              )}{" "}
              van de {Object.keys(preintake).length} vragen
            </p>
          </div>
          <ol
            role="list"
            className="flex max-w-full flex-wrap content-start justify-end gap-1.5 sm:gap-2 sm:pl-2"
          >
            {Object.entries(preintake).map(([key, value]) => (
              <li key={key}>
                {value != null && value !== "" ? (
                  <span className="block h-2 w-2 rounded-full bg-wa-accent sm:h-2.5 sm:w-2.5">
                    <span className="sr-only">{key}</span>
                  </span>
                ) : (
                  <span className="block h-2 w-2 rounded-full bg-wa-border sm:h-2.5 sm:w-2.5">
                    <span className="sr-only">{key}</span>
                  </span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>

      <div className="w-full border-b border-wa-border py-4">
        <nav
          aria-label="Voortgang klachtenregistratie"
          className="flex w-full flex-col gap-3 sm:flex-row sm:items-start sm:justify-between"
        >
          <div className="min-w-0 flex-shrink-0 sm:max-w-[50%]">
            <p className="text-sm font-semibold text-wa-text">
              {klachtenregistratie.title}
            </p>
            <p className="text-sm text-wa-muted">
              Ingevuld{" "}
              {
                Object.entries(klachtenregistratie.lijst).filter(
                  ([, value]) => value.length > 0
                ).length
              }{" "}
              van de {Object.keys(klachtenregistratie.lijst).length} Categorieen
            </p>
          </div>
          <ol
            role="list"
            className="flex max-w-full flex-wrap content-start justify-end gap-1.5 sm:gap-2 sm:pl-2"
          >
            {Object.entries(klachtenregistratie.lijst).map(([key, value]) => (
              <li key={key}>
                {value.length > 0 ? (
                  <div
                    title={benamingKlachtenObject[key]?.link}
                    className="block h-2 w-2 rounded-full bg-wa-accent sm:h-2.5 sm:w-2.5"
                  />
                ) : (
                  <div
                    title={benamingKlachtenObject[key]?.link}
                    className="block h-2 w-2 rounded-full bg-wa-border sm:h-2.5 sm:w-2.5"
                  >
                    <span className="sr-only">{key}</span>
                  </div>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>

      <div className="w-full py-4 pb-0">
        <nav
          aria-label="Voortgang voedingsdagboek"
          className="flex w-full flex-col gap-3 sm:flex-row sm:items-start sm:justify-between"
        >
          <div className="min-w-0 flex-shrink-0 sm:max-w-[50%]">
            <p className="text-sm font-semibold text-wa-text">
              VoedingsDagboek formulier
            </p>
            <p className="text-sm text-wa-muted">
              Ingevuld {voedingStatus} van de 3 vragen
            </p>
          </div>
          <ol
            role="list"
            className="flex max-w-full flex-wrap items-center justify-end gap-2 sm:gap-3 sm:pl-2"
          >
            {Array.from({ length: 3 }, (_, i) => (
              <li key={i}>
                {i <= voedingStatus ? (
                  <span className="block h-8 w-8 rounded-full bg-wa-accent sm:h-9 sm:w-9">
                    <span className="sr-only">stap {i + 1}</span>
                  </span>
                ) : (
                  <span className="block h-8 w-8 rounded-full bg-wa-border sm:h-9 sm:w-9">
                    <span className="sr-only">stap {i + 1}</span>
                  </span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default RPProgressbarVragenlijst;
